const ZENDESK_KEY = '3adff776-bc37-4e3e-b490-85a89122aaa2';
const SNIPPET_ID = 'ze-snippet';

let visible = false;
let suppressed = false;

const syncMessenger = () => {
  window.zE?.('messenger', visible && !suppressed ? 'show' : 'hide');
};

export const loadZendesk = () => {
  visible = true;
  if (document.getElementById(SNIPPET_ID)) {
    syncMessenger();
    return;
  }

  const script = document.createElement('script');
  script.id = SNIPPET_ID;
  script.src = `https://static.zdassets.com/ekr/snippet.js?key=${ZENDESK_KEY}`;
  script.onload = syncMessenger;

  document.body.appendChild(script);
};

export const unloadZendesk = () => {
  visible = false;
  syncMessenger();
};

// The launcher iframe sits above every in-app overlay, so full-screen layers hide it
export const suppressZendesk = (value: boolean) => {
  suppressed = value;
  syncMessenger();
};
